import { TreeCardObject } from '../tree-card/tree-card-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderStatusObject } from '../order-status-object.model';
import { OrderTypeObject } from '../order-type-object.model';

export class CfsOrderObject extends TreeCardObject {

    constructor(name: string, completed: boolean, crmId: string, operation: string,
        status: string, dependencies: boolean, orderId: string) {
        super(name, 'ORDEN DE SERVICIO (CFS)', StringUtils.NOT_AVALIABLE, completed,
            crmId, operation, OrderStatusObject.createWithStatus(status), dependencies, 3, orderId, OrderTypeObject.CFS);

        return this;
    }
}
